// import { MdDelete } from "react-icons/md";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import { ImStarFull } from "react-icons/im";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import SessionUtil from "../util/SessionUtil";

const ActionRow = ({ deleteRow, handleClickRow, data, page, id }) => {
  const { t } = useTranslation();

  return (
    // <MdDelete color="#9696A6" size={20} onClick={deleteRow} />
    <Dropdown>
      <Dropdown.Toggle bsPrefix="none" variant="none" className="border-0">
        <span>
          <BiDotsHorizontalRounded color="#B8B8C3" />
        </span>
      </Dropdown.Toggle>
      {page === "orderPending" ? (
        <Dropdown.Menu className="shadow-sm font-13">
          <Dropdown.Item onClick={() => handleClickRow(id)}>
            {t("Resend")}
          </Dropdown.Item>
        </Dropdown.Menu>
      ) : page === "driver" ? (
        <Dropdown.Menu className="shadow-sm font-13">
          <Dropdown.Item onClick={() => handleClickRow("driver", id, data)}>
            {t("Orders")}
          </Dropdown.Item>
        </Dropdown.Menu>
      ) : (
        <Dropdown.Menu className="shadow-sm font-13">
          <Dropdown.Item onClick={() => handleClickRow("item", data)}>
            {t("Items")}
          </Dropdown.Item>
          {data.PaymentStatus !== "PAID" && (
            <Dropdown.Item onClick={() => handleClickRow("paid", data)}>
              {t("Paid")}
            </Dropdown.Item>
          )}
         
        </Dropdown.Menu>
      )}
    </Dropdown>
  );
};

const StarDots = ({ isFavorite, handleClick, page, handleClickRow, data }) => {
  const { t } = useTranslation();
  const type = SessionUtil.getTypeUser();
  return (
    <div className="d-flex gap-4 justify-content-around align-items-center">
      <span>
        <ImStarFull
          size={18}
          color={isFavorite ? "#EEAE0B" : "#E9E9EC"}
          onClick={handleClick}
        />
      </span>
      {page === "store" ? (
        <Dropdown>
          <Dropdown.Toggle bsPrefix="none" variant="none" className="border-0">
            <span>
              <BiDotsHorizontalRounded color="#B8B8C3" />
            </span>
          </Dropdown.Toggle>

          <Dropdown.Menu className="shadow-sm font-13">
            {type === "4" && (
              <Dropdown.Item
                onClick={() => handleClickRow("stores-items", "new", data)}
              >
                {t("New Items")}
              </Dropdown.Item>
            )}
            {type === "4" && (
              <Dropdown.Item
                onClick={() => handleClickRow("stores-items", "all", data)}
              >
                {t("All Items")}
              </Dropdown.Item>
            )}
            <Dropdown.Item
              onClick={() => handleClickRow("Orders", "store", data)}
            >
              {t("Orders")}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      ) : (
        <span>
          <BiDotsHorizontalRounded color="#B8B8C3" />
        </span>
      )}
    </div>
  );
};

export { ActionRow, StarDots };
